module.exports = __webpack_public_path__ + "img/cases-brand-herborist-3.d6644714.jpg";